import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useState } from 'react';
import { LoadingScreen } from '@fortem-monorepo/react-ui';
export const DelayRender = ({ children, delay = 200 }) => {
    const [ready, setReady] = useState(false);
    useLayoutEffect(() => {
        setTimeout(() => {
            setReady(true);
        }, delay);
    }, []);
    if (ready) {
        return children;
    }
    return _jsx(LoadingScreen, {});
};
